/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassroomUserBulkSaveViewModel } from "../types/ClassroomUserBulkSaveViewModel.ts";
import { classroomUserBulkSaveItemViewModelSchema } from "./classroomUserBulkSaveItemViewModelSchema.ts";

export const classroomUserBulkSaveViewModelSchema = z.object({
  students: z
    .array(z.lazy(() => classroomUserBulkSaveItemViewModelSchema))
    .nullish(),
}) as unknown as ToZod<ClassroomUserBulkSaveViewModel>;
